import { render, staticRenderFns } from "./FieldView.vue?vue&type=template&id=87e960b0&"
import script from "./FieldView.vue?vue&type=script&lang=ts&"
export * from "./FieldView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports